import { Routes } from '@angular/router';
import { MfkComponent } from './mfk/mfk.component';

export const childRoutes: Routes = [
    {
        path: 'introduction',
        loadChildren: () => import('./introduction/introduction.module').then((m) => m.IntroductionModule),
        data: {
            linkText: 'Introduction',
            collapse: false,
            subtitle: [
                {
                    path: 'introduction/mfk',
                    name: 'Master File Key (MFK)',
                },
                {
                    path: 'introduction/who-key',
                    name: 'WhoKey',
                },
            ],
        },
    },
    {
        path: 'mfk',
        component: MfkComponent,
        data: {
            linkText: 'MFK Validation Tool',
            collapse: true
        }
    },
    {
        path: 'fund',
        loadChildren: () => import('./fund/fund.module').then((m) => m.FundModule),
        data: {
            linkText: 'Fund',
            collapse: false,
            subtitle: [
                {
                    path: 'fund/fund-definition',
                    name: 'Definition',
                },
                {
                    path: 'fund/fund-index',
                    name: 'Fund List',
                },
                {
                    path: 'fund/fund-table',
                    name: 'Fund Table',
                },
                {
                    path: 'fund/valid-fund',
                    name: 'Valid Fund/Function',
                },
            ],
        },
    },
    {
        path: 'org',
        loadChildren: () => import('./org/org.module').then((m) => m.OrgModule),
        data: {
            linkText: 'Organizational Unit',
            collapse: false,
            subtitle: [
                {
                    path: 'org/org-definition',
                    name: 'Definition',
                },
                {
                    path: 'org/org-list',
                    name: 'Org Unit List',
                },
            ],
        },
    },
    {
        path: 'dept-subdept',
        loadChildren: () => import('./dept-subdept/dept-subdept.module').then((m) => m.DeptSubdeptModule),
        data: {
            linkText: 'Department/Subdepartment',
            collapse: false,
            subtitle: [
                {
                    path: 'dept-subdept/dept-subdept-definition',
                    name: 'Definition',
                },
                {
                    path: 'dept-subdept/range-list',
                    name: 'Assigned Department Range per Org Unit',
                },
                {
                    path: 'dept-subdept/dept-list',
                    name: 'Department List',
                }
            ],
        },
    },
    {
        path: 'grant-program',
        loadChildren: () => import('./grant-program/grant-program.module').then((m) => m.GrantProgramModule),
        data: {
            linkText: 'Grant/Program',
            collapse: false,
            subtitle: [
                {
                    path: 'grant-program/grant-definition',
                    name: 'Definition',
                },
                {
                    path: 'grant-program/range',
                    name: 'Grant/Program Range',
                }
            ],
        },
    },
    {
        path: 'iact',
        loadChildren: () => import('./iact/iact.module').then((m) => m.IactModule),
        data: {
            linkText: 'Institutional Account',
            collapse: false,
            subtitle: [
                {
                    path: 'iact/iact-definition',
                    name: 'Definition',
                },
                {
                    path: 'iact/iact-list',
                    name: 'Institutional Account List',
                },
                {
                    path: 'iact/acquisitions',
                    name: 'Equip, Software & Leases Info'
                },
                {
                    path: 'iact/iact-memos',
                    name: 'Institutional Account Related Memos',
                }
            ],
        },
    },
    {
        path: 'oact',
        loadChildren: () => import('./oact/oact.module').then((m) => m.OactModule),
        data: {
            linkText: 'Organizational Account',
            collapse: false,
            subtitle: [
                {
                    path: 'oact/oact-definition',
                    name: 'Definition',
                },
            ],
        },
    },
    {
        path: 'dact',
        loadChildren: () => import('./dact/dact.module').then((m) => m.DactModule),
        data: {
            linkText: 'Departmental Account',
            collapse: false,
            subtitle: [
                {
                    path: 'dact/dact-definition',
                    name: 'Definition',
                },
            ],
        },
    },
    {
        path: 'fn',
        loadChildren: () => import('./fn/fn.module').then((m) => m.FnModule),
        data: {
            linkText: 'Function',
            collapse: false,
            subtitle: [
                {
                    path: 'fn/fn-definition',
                    name: 'Definition',
                },
                {
                    path: 'fn/fn-index',
                    name: 'Function List',
                },
                {
                    path: 'fund/valid-fund',
                    name: 'Valid Fund/Function',
                },
                {
                    path: 'fn/fn-memos',
                    name: 'Function Related Memos',
                },
            ],
        },
    },
    {
        path: 'cost-ctr',
        loadChildren: () => import('./cost-ctr/cost-ctr.module').then((m) => m.CostCtrModule),
        data: {
            linkText: 'Cost Center',
            collapse: false,
            subtitle: [
                {
                    path: 'cost-ctr/cctr-definition',
                    name: 'Definition',
                },
                {
                    path: 'cost-ctr/ccfacranges',
                    name: 'Faculty Ranges (by Org Unit)',
                },
                {
                    path: 'cost-ctr/faclist',
                    name: 'Cost Center Faculty',
                },
                {
                    path: 'cost-ctr/buildinglist',
                    name: 'Buildings (Range 0001-0699)',
                },
                {
                    path: 'cost-ctr/improvements',
                    name: 'Improvements (Range 0700-0899)',
                },
                {
                    path: 'cost-ctr/other',
                    name: 'Other (Range 0900-0999)',
                }
            ],
        },
    },
    {
        path: 'brf',
        loadChildren: () => import('./brf/brf.module').then((m) => m.BRFModule),
        data: {
            linkText: 'Budget Reference Field',
            collapse: false,
            subtitle: [
                {
                    path: 'brf/brf-definition',
                    name: 'Definition',
                },
            ],
        },
    },
    {
        path: 'search',
        loadChildren: () => import('./search/search.module').then((m) => m.SearchModule),
        data: {
            linkText: 'GL Chartfield Search',
            collapse: true
        },
    },
    {
        path: '**',
        redirectTo: '',
    },
];
export interface LinkItem {
    //icon: FaIconComponent;
    text: string;
    path: string;
    collapse: boolean;
    subtitle: [];
}
export const childRouteLinkItems: LinkItem[] = childRoutes.map((x) => {
    return {
        //icon: x.data.icon,
        text: x.data?.linkText,
        path: x.path,
        collapse: x.data?.collapse,
        subtitle: x.data?.subtitle,
    } as LinkItem;
});
